import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getApiWarehousesOptions,
  type GetApiWarehousesError,
  type WarehouseDto,
} from '@/api';

import { toWarehousesQuery, type ActivityFilter } from '../lib/searchParams';

/** Склады 1С по признаку действия, по наименованию. */
export const useWarehousesList = (
  activity: ActivityFilter,
): UseQueryResult<Array<WarehouseDto>, GetApiWarehousesError> =>
  useQuery({
    ...getApiWarehousesOptions({ query: toWarehousesQuery(activity) }),
    placeholderData: (previous) => previous,
  });
